module.exports = __webpack_public_path__ + "img/case_histologico.e22e47fe.png";